export const extractTdContent = (htmlData) => {
    // Use DOMParser to parse the HTML string
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlData, 'text/html');
  
    // Select all <td> elements and map their text content into an array
    const tdContentArray = Array.from(doc.querySelectorAll('td')).map(td => td.textContent.trim());
  
    return tdContentArray;
  };
  